import { render, staticRenderFns } from "./EndClient.vue?vue&type=template&id=28a95d90"
import script from "./EndClient.vue?vue&type=script&lang=js"
export * from "./EndClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports